import { Service } from '@genial/services';
import { selector } from 'recoil';

import { screenName } from './constants';

export const yearsQuery = selector({
  key: 'ManagementAnalysis/YearsQuery',
  get: async () => {
    const { data } = await Service.ReportingServices.V1.getReportingAvailableYears({
      screenName,
    });

    return data.year?.sort((a, b) => b - a)?.map((year) => year.toString()) || [];
  },
});

export const firstYear = selector({
  key: 'ManagementAnalysis/FirstYear',
  get: ({ get }) => {
    const years = get(yearsQuery);
    return years?.[0] || new Date().getFullYear().toString();
  },
});
